import { SectorMine } from '../../../../models/sector-mine';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';

import { map, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const base_url = environment.base_url;
const base_url_fast = environment.base_url_fast;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('Galio:Emt.532%')
  })
};

@Injectable({
  providedIn: 'root'
})
export class SectorsService {

  constructor(private http: HttpClient) { }

  // getSectors(): Observable<SectorMine[]>{
  //   const url = `${ base_url }/sector`;
  //   return this.http.get( url )
  //             .pipe(
  //               map( (resp: {ok: boolean, objects: SectorMine[] }) => resp.objects )
  //             );
  // }

  getSectorsByMine( id: string ): Observable<SectorMine[]>{
    console.log('ID MINE: '+id);
    const url = `${ base_url_fast }/faena/sector/${id}`;
    return this.http.post( url, null, httpOptions )
              .pipe(
                map( (resp: {ok: boolean, objects: SectorMine[] }) => resp.objects )
              );
  }

  getSectorById(id: string): Observable<SectorMine[]>{

    const url = `${ base_url_fast }/sector/${id}`;
    return this.http.get( url, httpOptions )
              .pipe(
                map( (resp: {ok: boolean, objects: SectorMine[] }) => resp.objects )
              );
  }


  updateSector(form: any, id: string): Observable<SectorMine[]>{

    const url = `${ base_url_fast }/sector/${id}`;
    return this.http.put( url, form, httpOptions )
              .pipe(
                map( (resp: {ok: boolean, objects: SectorMine[] }) => resp.objects )
              );
  }


  createSector(form: any) {

    console.log('SERVICE FAENA_ '+form.faena_id);
    const url = `${ base_url_fast }/sector`;
    const req = this.http.post(url, form, httpOptions);
    return req;
  }




}

